import { Empty } from "antd";
import { useTranslation } from "react-i18next";

const MappingEmptyState = () => {
  const { t } = useTranslation();

  return <Empty description={t("no_data")} image={Empty.PRESENTED_IMAGE_SIMPLE} />;
};

export default MappingEmptyState;
